import { apiRequest, constructUrlWithQueryParams } from '@utils/request';
import { WebsiteDocument, WebsiteDocumentRequest } from 'types/documents';

export async function getWebsiteDocument(title: string): Promise<WebsiteDocument> {
	const websiteDocumentRequest: WebsiteDocumentRequest = { title };
	const response = await apiRequest.get(constructUrlWithQueryParams('/website-documents', websiteDocumentRequest));

	return response.data;
}
